import { useEffect } from 'react'
import { usePriceVolatility } from '../api/prices'
import { mapVolatilityEntries } from '../mappers/volatilityMapper'
import { usePriceVolatilityStore } from '@/stores/priceVolatilityStore'

export function usePriceVolatilityQuery() {
  const { filters, setEntries, entries } = usePriceVolatilityStore()
  const query = usePriceVolatility(filters)

  useEffect(() => {
    if (query.data?.data) {
      setEntries(mapVolatilityEntries(query.data.data))
    }
  }, [query.data, setEntries])

  return {
    ...query,
    entries,
    filters,
  }
}
